import { Link } from "react-router-dom";
import { url } from "../../Config/Config";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

function BreadCrumb(props: any) {
  return (
    <Fragment>
      <ol className="breadcrumb m-0">
        <li className="breadcrumb-item">
          <Link to={url + "/dashboard"}>
            <i className="bx bx-home-circle"></i>
            <FormattedMessage id="dashboard" />
          </Link>
        </li>
        {props && props.thirdLast && (
          <li className="breadcrumb-item active">
            <Link to={url + props?.thirdLast?.link}>
              {props?.thirdLast?.name}
            </Link>{" "}
          </li>
        )}
        {props && props.secLast && (
          <li className="breadcrumb-item active">
            <Link to={url + props?.secLast?.link}>
              {props?.secLast?.name}
            </Link>{" "}
          </li>
        )}
        {props && props.Last && (
          <li className="breadcrumb-item">{props?.Last?.name} </li>
        )}
      </ol>
    </Fragment>
  );
}

export default BreadCrumb;
